import ApiService from '@/common/api.service'
import * as action from '@/store/action.types'
import * as mutation from '@/store/mutation.types'
import { FETCH_SESSION_HISTORY_DATA_URL } from '@/constants/ApiConstants'

const state = {
    info: [],
    sessions: []
}

const getters = {
    playerInfo: (state) => state.info,
    playerSessions: (state) => state.sessions
}

const actions = {
    [action.FETCH_SESSION_HISTORY_DATA]({commit}, payload) {
        const { playerId } = payload;
        return new Promise((resolve, reject) => {
            ApiService
              .get(`${FETCH_SESSION_HISTORY_DATA_URL.replace(':playerId', payload.playerId)}`, {
                  sort : `${payload.sortColumn},${payload.sortDirection}`,
                  size : payload.pageSize,
                  page: payload.pageNum,
                  playerInfo: payload.playerInfo
              })
                .then(({ data }) => {
                    commit(mutation.SET_SESSION_HISTORY_DATA, { payload: data, updateInfo: payload.playerInfo })
                    return resolve(data)
                    
                })
                .catch(error => {
                    return reject(error)
                })
        })
    }
}

const mutations = {
    [mutation.SET_SESSION_HISTORY_DATA] (state, { payload, updateInfo}) {
        if(updateInfo) {
            state.info = payload.playerInfo
        }

        state.sessions = payload.playerSessions
    }
}

export default {
    state,
    actions,
    mutations,
    getters
  }
